const Types = {
  FETCH_PATIENTS_START: 'patients/FETCH_PATIENTS_START',
  FETCH_PATIENTS_SUCCESS: 'patients/FETCH_PATIENTS_SUCCESS',
  FETCH_PATIENTS_ERROR: 'patients/FETCH_PATIENTS_ERROR',
  CLEAR_PATIENTS: 'patients/CLEAR_PATIENTS',
  // FILTER_CHARACTERS: 'characters/FILTER_CHARACTERS',
};

export default Types;
